import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Row, Col, Alert, Button, Icon } from 'antd';
import { Link } from 'react-router';
import classes from '../styles/withdrawal/WithdrawalInfo.module.scss';
import { formatNumber, formatPvCode } from 'utils/formatting';
const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};

const WithdrawalHeader = ({ withdrawal, onOpenRemarkModal, Tabs }) => {
  console.log(withdrawal);
  const teacher = withdrawal.teacher;
  const requestDate = moment(withdrawal.createdAt).format('DD/MM/YYYY HH:mm');
  const approvedDate = withdrawal.approvedDate ? moment(withdrawal.approvedDate).format('DD/MM/YYYY HH:mm') : 'n/a';
  return (
    <div className={cn('content-header', classes.headerContainer)}>
      <Row className={classes.headerContent}>
        <Col xs={24}>
          <Button className={'pull-right'} onClick={onOpenRemarkModal}>
            <Icon type="pushpin" />
            Edit remark
          </Button>
          <div className="header-title">
            <span className="bold">Withdrawal: </span>
            {withdrawal.code}
          </div>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col xs={3}>
          <div className={classes.imageContainer}>
            <img className={cn(classes.profileImage)} src={teacher.displayImage} />
          </div>
        </Col>
        <Col xs={9}>
          <div>
            <span className="bold">Name:</span> <Link to={`/teacher/${teacher._id}`}>{`${teacher.name.first} ${teacher.name.last}`}</Link>
          </div>
          <div>
            <span className="bold">Status:</span> {withdrawal.status}
          </div>
          <div>
            <span className="bold">Request Date: </span>
            {requestDate}
          </div>
        </Col>
        <Col xs={9}>
          <div>
            <span className="bold">Bank:</span> {withdrawal.bankName}
          </div>
          <div>
            <span className="bold">Account No.:</span> {withdrawal.bankAccount}
          </div>
          <div>
            <span className="bold">Total Payout:</span> {formatPrice(withdrawal.withdrawAmount)}
          </div>
          <div>
            <span className="bold">Transfer Date:</span> {approvedDate}
          </div>
          <div>
            <span className="bold">PV No.: </span>
            {formatPvCode(withdrawal)}
          </div>
        </Col>
      </Row>
      {withdrawal.remark && (
        <Row>
          <Col xs={24}>
            <span className="bold"> Remark: </span>
            <span className="remark-text">{withdrawal.remark}</span>
          </Col>
        </Row>
      )}
      {Tabs}
    </div>
  );
};

export default WithdrawalHeader;
